import React, { createContext, FC, useRef } from 'react';
import { AppRouter } from 'components/base/AppRouter';
import { inject, observer } from 'mobx-react';
import { Toast } from 'primereact/toast';
import { Helmet } from 'react-helmet';

export const ToastContext =
  createContext<React.MutableRefObject<Toast | null> | null>(null);

const App: FC = inject('rootStore')(
  observer(() => {
    const toast = useRef<Toast | null>(null);
    return (
      <>
        <ToastContext.Provider value={toast}>
          <Helmet>
            <meta
              name="version"
              content={process.env.REACT_APP_VERSION}
            />
          </Helmet>
          <AppRouter />
        </ToastContext.Provider>
        <Toast ref={toast} />
      </>
    );
  }),
);

export default App;
